<template>
	<div>
		<div class="card-base image-box rounded-3">
			<seo-image :data="image.background" :class="'image-box-img'" :alt="'ImageBox image'" />
		</div>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue';
import {ImageComponentClass, ImageComponentInterface} from "../../Views/PageView/Interfaces/Components/ImageComponentInterface";
import SeoImage from "../SeoImage.vue";

export default defineComponent({
	name: 'ImageBox',
	components: {SeoImage},
	props: {
		image: {
			type: Object as PropType<ImageComponentInterface>,
			default: new ImageComponentClass(),
			required: true
		}
	},
});
</script>

<style lang="scss" scoped>

</style>
